<template>
  <modal name="jobs919-dialog" :adaptive="true" :scrollable="true" height="auto" :clickToClose="true"
    @before-close="handleBeforeClose">
    <div class="v--modal-close-top" v-loading.fullscreen.lock="fullscreenLoading">
      <el-button @click="closeJobs919Dialog" icon="el-icon-circle-close" style="font-size: 2rem;"
        type="text"></el-button>
    </div>
    <div class="setting" v-if="permissionType == 1 || permissionType == 7">

      <div class="setting-item" style="text-align:center;">
        <p>ダウンロードが完了しました！！！</p>
        <p style="font-size: 1rem; font-weight: bold;">今作成した履歴書をもとに<br>プロが好条件の勤め先をご紹介します！</p>

        <div style="text-align:center; background: #F7F7F7; padding: 10px; margin-top: 10px;"
          :id="!$globalVar.googleAdsTagCheck(clientId, permissionType) ? 'pdf-' + $globalVar.dn_flag + '-rt-completed' : clientId + '_' + permissionType + '_btn'"
          @click="$eventHub.$emit('send-jobs919-consult');">
          <p style="display: inline-block; margin: 10px;">
            <img src="/static/renew2_img/919kensetsu_yagish_logo_20230810.png" alt="システムシェアードとヤギッシュ">
          </p>

          <p style="font-size: 16px; font-weight: bold;"><img src="/static/renew_img/check_icon.png" alt="同意する"
              style="height: 30px;">
            規約に同意して無料相談を希望する</p>
        </div>

        <div class="text-center" v-if="!$globalVar.googleAdsTagCheck(clientId, permissionType)">
          <el-button :id="'pdf-' + $globalVar.dn_flag + '-rt-completed'" type="success" v-if="isJobs919Sended == false"
            style="font-size: 18px; font-weight: bold; margin-top: 0; display: block; width: 100%; background: rgb(227, 22, 92); border: rgb(227, 22, 92); padding: 20px; border-radius: 4px;"
            @click="$eventHub.$emit('send-jobs919-consult');">同意する</el-button>
          <el-button :id="'pdf-' + $globalVar.dn_flag + '-rt-completed-done'" type="success"
            v-if="isJobs919Sended == true" style="background-color:#0F9934;border-color:#0F9934;"
            @click="closeJobs919Dialog();">送信しました</el-button>
          <br />
        </div>
        <div class="text-center" v-else>
          <el-button :id="clientId + '_' + permissionType + '_btn'" type="success" v-if="isJobs919Sended == false"
            style="font-size: 18px; font-weight: bold; margin-top: 0; display: block; width: 100%; background: rgb(227, 22, 92); border: rgb(227, 22, 92); padding: 20px; border-radius: 4px;"
            @click="$eventHub.$emit('send-jobs919-consult');">同意する</el-button>
          <el-button :id="'pdf-' + $globalVar.dn_flag + '-rt-completed-done'" type="success"
            v-if="isJobs919Sended == true" style="background-color:#0F9934;border-color:#0F9934;"
            @click="closeJobs919Dialog();">送信しました</el-button>
          <br />
        </div>

        <div style="margin-top: 20px; text-align: center;">
          <p style="font-size: 10px;">
            Yagishの<router-link id="footer-link-terms" :to="{ name: 'termsPage' }"
              target="_blank">利用規約</router-link>、<router-link id="footer-link-policy" :to="{ name: 'policyPage' }"
              target="_blank">個人情報保護方針</router-link>、<a href="https://www.yagish.jp/privacy_policy/"
              target="_blank">プライバシーポリシー</a><br />
            (株)クイックの<a href="https://plant.ten-navi.com/ruleprivacy/" target="_blank">利用規約</a>、<a
              href="https://plant.ten-navi.com/ruleprivacy/" target="_blank">個人情報保護方針</a>を
            <br>確認して建設・設備求人データベースに登録することになります。
          </p>

          <p style="font-size: 10px; margin-top: 10px;">ご同意いただいた方には追って<br>連絡がいきますのでご確認お願いいたします！</p>
        </div>

      </div>

    </div>
    <div class="setting" v-else-if="permissionType == 2 || permissionType == 8 || permissionType == 9">

      <div class="setting-item" style="text-align:center;">
        <p>ダウンロードが完了しました！！！</p>
        <p style="font-size: 1rem; font-weight: bold;">今作成した履歴書をもとに<br>プロが好条件の勤め先をご紹介します！</p>

        <div style="text-align:center; background: #F7F7F7; padding: 10px; margin-top: 10px;"
          :id="!$globalVar.googleAdsTagCheck(clientId, permissionType) ? 'pdf-' + $globalVar.dn_flag + '-rt-completed' : clientId + '_' + permissionType + '_btn'"
          @click="$eventHub.$emit('send-jobs919-consult');">

          <p style="display: inline-block; margin: 10px;">
            <img src="/static/renew2_img/919jobs_yagish_logo_20230810.png" alt="システムシェアードとヤギッシュ">
          </p>
          <p style="font-size: 16px; font-weight: bold;">
            <img src="/static/renew_img/check_icon.png" style="width:40px">規約に同意して無料相談を同意する
          </p>
        </div>
        <div class="text-center" v-if="!$globalVar.googleAdsTagCheck(clientId, permissionType)">
          <el-button :id="'pdf-' + $globalVar.dn_flag + '-rt-completed'" type="success" v-if="isJobs919Sended == false"
            style="font-size: 18px; font-weight: bold; margin-top: 0; display: block; width: 100%; background: rgb(227, 22, 92); border: rgb(227, 22, 92); padding: 20px; border-radius: 4px;"
            @click="$eventHub.$emit('send-jobs919-consult');">同意する</el-button>
          <el-button :id="'pdf-' + $globalVar.dn_flag + '-rt-completed-done'" type="success"
            v-if="isJobs919Sended == true" style="background-color:#0F9934;border-color:#0F9934;"
            @click="closeJobs919Dialog();">送信しました</el-button>
          <br />
        </div>
        <div class="text-center" v-else>
          <el-button :id="clientId + '_' + permissionType + '_btn'" type="success" v-if="isJobs919Sended == false"
            style="font-size: 18px; font-weight: bold; margin-top: 0; display: block; width: 100%; background: rgb(227, 22, 92); border: rgb(227, 22, 92); padding: 20px; border-radius: 4px;"
            @click="$eventHub.$emit('send-jobs919-consult');">同意する</el-button>
          <el-button :id="'pdf-' + $globalVar.dn_flag + '-rt-completed-done'" type="success"
            v-if="isJobs919Sended == true" style="background-color:#0F9934;border-color:#0F9934;"
            @click="closeJobs919Dialog();">送信しました</el-button>
          <br />
        </div>

        <div style="margin-top: 20px; text-align: center;">
          <p style="font-size: 10px;">
            Yagishの<router-link id="footer-link-terms" :to="{ name: 'termsPage' }"
              target="_blank">利用規約</router-link>、<router-link id="footer-link-policy" :to="{ name: 'policyPage' }"
              target="_blank">個人情報保護方針</router-link>、<a href="https://www.yagish.jp/privacy_policy/"
              target="_blank">プライバシーポリシー</a><br />
            (株)クイックの<a href="https://plant.ten-navi.com/ruleprivacy/" target="_blank">利用規約</a>、<a
              href="https://plant.ten-navi.com/ruleprivacy/" target="_blank">個人情報保護方針</a>を
            <br>確認して整備士JOBSに登録することになります。
          </p>

          <p style="font-size: 10px; margin-top: 10px;">ご同意いただいた方には追って<br>連絡がいきますのでご確認お願いいたします！</p>
        </div>

      </div>

    </div>
    <div class="setting" v-else-if="permissionType == 3">
      <div class="setting-item" style="text-align:center;">
        <p>ダウンロードが完了しました！！！</p>
        <p style="font-size: 1rem; font-weight: bold;">今作成した履歴書をもとに<br>プロが好条件の建築士の勤め先をご紹介します！</p>

        <div style="text-align:center; background: #F7F7F7; padding: 10px; margin-top: 10px;"
          :id="!$globalVar.googleAdsTagCheck(clientId, permissionType) ? 'pdf-' + $globalVar.dn_flag + '-rt-completed' : clientId + '_' + permissionType + '_btn'"
          @click="$eventHub.$emit('send-jobs919-consult');">

          <!--企業ロゴ-->
          <div style="display: inline-block; min-width: 100%; text-align: center; padding: 10px;">
            <img src="/static/renew2_img/919kensetsu_yagish_logo_20230810.png" style="max-width: 90%;">
          </div>

          <p style="font-size: 16px; font-weight: bold;">
            <img src="/static/renew_img/check_icon.png" style="width:40px">規約に同意して無料相談を同意する
          </p>
        </div>
        <div class="text-center" v-if="!$globalVar.googleAdsTagCheck(clientId, permissionType)">
          <el-button :id="'pdf-' + $globalVar.dn_flag + '-rt-completed'" type="success" v-if="isJobs919Sended == false"
            style="font-size: 18px; font-weight: bold; margin-top: 0; display: block; width: 100%; background: rgb(227, 22, 92); border: rgb(227, 22, 92); padding: 20px; border-radius: 4px;"
            @click="$eventHub.$emit('send-jobs919-consult');">同意する</el-button>
          <el-button :id="'pdf-' + $globalVar.dn_flag + '-rt-completed-done'" type="success"
            v-if="isJobs919Sended == true" style="background-color:#0F9934;border-color:#0F9934;"
            @click="closeJobs919Dialog();">送信しました</el-button>
          <br />
        </div>
        <div class="text-center" v-else>
          <el-button :id="clientId + '_' + permissionType + '_btn'" type="success" v-if="isJobs919Sended == false"
            style="font-size: 18px; font-weight: bold; margin-top: 0; display: block; width: 100%; background: rgb(227, 22, 92); border: rgb(227, 22, 92); padding: 20px; border-radius: 4px;"
            @click="$eventHub.$emit('send-jobs919-consult');">同意する</el-button>
          <el-button :id="'pdf-' + $globalVar.dn_flag + '-rt-completed-done'" type="success"
            v-if="isJobs919Sended == true" style="background-color:#0F9934;border-color:#0F9934;"
            @click="closeJobs919Dialog();">送信しました</el-button>
          <br />
        </div>

        <div style="margin-top: 20px; text-align: center;">
          <p style="font-size: 10px;">
            Yagishの<router-link id="footer-link-terms" :to="{ name: 'termsPage' }"
              target="_blank">利用規約</router-link>、<router-link id="footer-link-policy" :to="{ name: 'policyPage' }"
              target="_blank">個人情報保護方針</router-link>、<a href="https://www.yagish.jp/privacy_policy/"
              target="_blank">プライバシーポリシー</a><br />
            (株)クイックの<a href="https://plant.ten-navi.com/ruleprivacy/" target="_blank">利用規約</a>、<a
              href="https://plant.ten-navi.com/ruleprivacy/" target="_blank">個人情報保護方針</a>を
            <br>確認して建設・設備求人データベースに登録することになります。
          </p>

          <p style="font-size: 10px; margin-top: 10px;">ご同意いただいた方には追って<br>連絡がいきますのでご確認お願いいたします！</p>
        </div>

      </div>

    </div>
    <div class="setting" v-else-if="permissionType == 4">
      <div class="setting-item" style="text-align:center;">
        <p>ダウンロードが完了しました！！！</p>
        <p style="font-size: 1rem; font-weight: bold;">今作成した履歴書をもとに<br>プロが好条件の電気主任技術者の勤め先をご紹介します！</p>

        <div style="text-align:center; background: #F7F7F7; padding: 10px; margin-top: 10px;"
          :id="!$globalVar.googleAdsTagCheck(clientId, permissionType) ? 'pdf-' + $globalVar.dn_flag + '-rt-completed' : clientId + '_' + permissionType + '_btn'"
          @click="$eventHub.$emit('send-jobs919-consult');">

          <!--企業ロゴ-->
          <div style="display: inline-block; min-width: 100%; text-align: center; padding: 10px;">
            <img src="/static/renew2_img/919kensetsu_yagish_logo_20230810.png" style="max-width: 90%;">
          </div>

          <p style="font-size: 16px; font-weight: bold;">
            <img src="/static/renew_img/check_icon.png" style="width:40px">規約に同意して無料相談を同意する
          </p>
        </div>
        <div class="text-center" v-if="!$globalVar.googleAdsTagCheck(clientId, permissionType)">
          <el-button :id="'pdf-' + $globalVar.dn_flag + '-rt-completed'" type="success" v-if="isJobs919Sended == false"
            style="font-size: 18px; font-weight: bold; margin-top: 0; display: block; width: 100%; background: rgb(227, 22, 92); border: rgb(227, 22, 92); padding: 20px; border-radius: 4px;"
            @click="$eventHub.$emit('send-jobs919-consult');">同意する</el-button>
          <el-button :id="'pdf-' + $globalVar.dn_flag + '-rt-completed-done'" type="success"
            v-if="isJobs919Sended == true" style="background-color:#0F9934;border-color:#0F9934;"
            @click="closeJobs919Dialog();">送信しました</el-button>
          <br />
        </div>
        <div class="text-center" v-else>
          <el-button :id="clientId + '_' + permissionType + '_btn'" type="success" v-if="isJobs919Sended == false"
            style="font-size: 18px; font-weight: bold; margin-top: 0; display: block; width: 100%; background: rgb(227, 22, 92); border: rgb(227, 22, 92); padding: 20px; border-radius: 4px;"
            @click="$eventHub.$emit('send-jobs919-consult');">同意する</el-button>
          <el-button :id="'pdf-' + $globalVar.dn_flag + '-rt-completed-done'" type="success"
            v-if="isJobs919Sended == true" style="background-color:#0F9934;border-color:#0F9934;"
            @click="closeJobs919Dialog();">送信しました</el-button>
          <br />
        </div>

        <div style="margin-top: 20px; text-align: center;">
          <p style="font-size: 10px;">
            Yagishの<router-link id="footer-link-terms" :to="{ name: 'termsPage' }"
              target="_blank">利用規約</router-link>、<router-link id="footer-link-policy" :to="{ name: 'policyPage' }"
              target="_blank">個人情報保護方針</router-link>、<a href="https://www.yagish.jp/privacy_policy/"
              target="_blank">プライバシーポリシー</a><br />
            (株)クイックの<a href="https://plant.ten-navi.com/ruleprivacy/" target="_blank">利用規約</a>、<a
              href="https://plant.ten-navi.com/ruleprivacy/" target="_blank">個人情報保護方針</a>を
            <br>確認して建設・設備求人データベースに登録することになります。
          </p>

          <p style="font-size: 10px; margin-top: 10px;">ご同意いただいた方には追って<br>連絡がいきますのでご確認お願いいたします！</p>
        </div>

      </div>

    </div>
    <div class="setting" v-else-if="permissionType == 5">

      <div style="text-align: center;">
        <p style="font-weight: bold; font-size: 120%;">ダウンロードが完了しました！</p>
        <p style="font-weight: bold; font-size: 120%;">履歴書を作成いただいた看護師さん向けに</p>
        <p style="font-weight: bold; font-size: 120%;margin-bottom: 10px;">プロが好条件の求人をご紹介します！</p>

        <!--オススメリスト-->
        <div style="text-align:center; background: #F7F7F7; padding: 10px; margin-top: 10px;"
          :id="!$globalVar.googleAdsTagCheck(clientId, permissionType) ? 'pdf-' + $globalVar.dn_flag + '-rt-completed' : clientId + '_' + permissionType + '_btn'"
          @click="$eventHub.$emit('send-jobs919-consult');">
          <!--企業ロゴ-->
          <div style="display: inline-block; min-width: 100%; text-align: center; padding: 10px;">
            <img src="/static/renew2_img/job919_roo_20230915_yagish_logo.png" style="max-width: 90%;">
          </div>

          <p style="font-size: 16px; font-weight: bold;">
            <img src="/static/renew_img/check_icon.png" style="width:40px">規約に同意して無料相談を希望する
          </p>
        </div>
        <div class="text-center" v-if="!$globalVar.googleAdsTagCheck(clientId, permissionType)">
          <el-button :id="'pdf-' + $globalVar.dn_flag + '-rt-completed'" type="success" v-if="isJobs919Sended == false"
            style="font-size: 18px; font-weight: bold; margin-top: 0; display: block; width: 100%; background: rgb(227, 22, 92); border: rgb(227, 22, 92); padding: 20px; border-radius: 4px;"
            @click="$eventHub.$emit('send-jobs919-consult');">同意する</el-button>
          <el-button :id="'pdf-' + $globalVar.dn_flag + '-rt-completed-done'" type="success"
            v-if="isJobs919Sended == true" style="background-color:#0F9934;border-color:#0F9934;"
            @click="closeJobs919Dialog();">送信しました</el-button>
          <br />
        </div>
        <div class="text-center" v-else>
          <el-button :id="clientId + '_' + permissionType + '_btn'" type="success" v-if="isJobs919Sended == false"
            style="font-size: 18px; font-weight: bold; margin-top: 0; display: block; width: 100%; background: rgb(227, 22, 92); border: rgb(227, 22, 92); padding: 20px; border-radius: 4px;"
            @click="$eventHub.$emit('send-jobs919-consult');">同意する</el-button>
          <el-button :id="'pdf-' + $globalVar.dn_flag + '-rt-completed-done'" type="success"
            v-if="isJobs919Sended == true" style="background-color:#0F9934;border-color:#0F9934;"
            @click="closeJobs919Dialog();">送信しました</el-button>
          <br />
        </div>

        <div style="margin-top: 20px; text-align: center;">
          <p style="font-size: 10px;">
            Yagishの<router-link id="footer-link-terms" :to="{ name: 'termsPage' }"
              target="_blank">利用規約</router-link>、<router-link id="footer-link-policy" :to="{ name: 'policyPage' }"
              target="_blank">個人情報保護方針</router-link>、<a href="https://www.yagish.jp/privacy_policy/"
              target="_blank">プライバシーポリシー</a><br />
            (株)クイックの<a href="https://www.kango-roo.com/career/rule" target="_blank">利用規約</a>、<a
              href="https://www.kango-roo.com/career/entry/ruleprivacy" target="_blank">個人情報保護方針</a>
          </p>

          <p style="font-size: 10px; margin-top: 10px;">
            ご同意いただいた方には追ってご連絡させて<br>いただきますので、ご確認お願いいたします。</p>
        </div>

      </div>

    </div>

    <div class="setting" v-else-if="permissionType == 6">

      <div style="text-align: center;">
        <p style="font-weight: bold; font-size: 120%;">ダウンロードが完了しました！</p>
        <p style="font-weight: bold; font-size: 120%;">今作成した履歴書をもとに</p>
        <p style="font-weight: bold; font-size: 120%;margin-bottom: 10px;">プロが好条件の製薬業界の勤め先をご紹介します！</p>

        <!--オススメリスト-->
        <div style="text-align:center; background: #F7F7F7; padding: 10px; margin-top: 10px;"
          :id="!$globalVar.googleAdsTagCheck(clientId, permissionType) ? 'pdf-' + $globalVar.dn_flag + '-rt-completed' : clientId + '_' + permissionType + '_btn'"
          @click="$eventHub.$emit('send-jobs919-consult');">
          <!--企業ロゴ-->
          <div style="display: inline-block; min-width: 100%; text-align: center; padding: 10px;">
            <img src="/static/renew2_img/job919answers_yagish_logo.png" style="max-width: 90%;">
          </div>

          <p style="font-size: 16px; font-weight: bold;">
            <img src="/static/renew_img/check_icon.png" style="width:40px">規約に同意して無料相談を希望する
          </p>
        </div>
        <div class="text-center" v-if="!$globalVar.googleAdsTagCheck(clientId, permissionType)">
          <el-button :id="'pdf-' + $globalVar.dn_flag + '-rt-completed'" type="success" v-if="isJobs919Sended == false"
            style="font-size: 18px; font-weight: bold; margin-top: 0; display: block; width: 100%; background: rgb(227, 22, 92); border: rgb(227, 22, 92); padding: 20px; border-radius: 4px;"
            @click="$eventHub.$emit('send-jobs919-consult');">同意する</el-button>
          <el-button :id="'pdf-' + $globalVar.dn_flag + '-rt-completed-done'" type="success"
            v-if="isJobs919Sended == true" style="background-color:#0F9934;border-color:#0F9934;"
            @click="closeJobs919Dialog();">送信しました</el-button>
          <br />
        </div>
        <div class="text-center" v-else>
          <el-button :id="clientId + '_' + permissionType + '_btn'" type="success" v-if="isJobs919Sended == false"
            style="font-size: 18px; font-weight: bold; margin-top: 0; display: block; width: 100%; background: rgb(227, 22, 92); border: rgb(227, 22, 92); padding: 20px; border-radius: 4px;"
            @click="$eventHub.$emit('send-jobs919-consult');">同意する</el-button>
          <el-button :id="'pdf-' + $globalVar.dn_flag + '-rt-completed-done'" type="success"
            v-if="isJobs919Sended == true" style="background-color:#0F9934;border-color:#0F9934;"
            @click="closeJobs919Dialog();">送信しました</el-button>
          <br />
        </div>

        <div style="margin-top: 20px; text-align: center;">
          <p style="font-size: 10px;">
            Yagishの<router-link id="footer-link-terms" :to="{ name: 'termsPage' }"
              target="_blank">利用規約</router-link>、<router-link id="footer-link-policy" :to="{ name: 'policyPage' }"
              target="_blank">個人情報保護方針</router-link>、<a href="https://www.yagish.jp/privacy_policy/"
              target="_blank">プライバシーポリシー</a><br />
            (株)クイックの<a href="https://www.kango-roo.com/career/rule" target="_blank">利用規約</a>、<a
              href="https://www.kango-roo.com/career/entry/ruleprivacy" target="_blank">個人情報保護方針</a>を<br>
            確認してAnswersに登録することになります。
          </p>

          <p style="font-size: 10px; margin-top: 10px;">ご同意いただいた方には追って<br>ご連絡がいきますので、ご確認お願いいたします！</p>
        </div>

      </div>

    </div>

    <div class="setting" v-else-if="permissionType == 0">

      <div style="text-align: center;">

        <p style="margin-bottom: 10px;">ダウンロードが完了しました！</p>
        <p style="margin-bottom: 10px;">看護師転職のプロがあなたにあった<br>好条件の転職先を紹介するよ！</p>

        <!--オススメリスト-->
        <div style="display: inline-block; min-width: 100%; text-align: center; ">
          <div
            style="text-align: left; margin-left: 0.5rem; font-size: 120%; font-weight: bold; line-height: 1.3; margin-bottom: 20px;">
            <div style="padding-bottom: 10px; display: flex; align-items: center;">
              <p
                style="display: block; background:#0F9934; width: 20px; height: 20px; border-radius: 50%; margin-right: 10px;">
              </p>
              <p style="font-size: 120%; font-weight: bold;">看護師に特化した求人・転職サイト<br>だからいい求人を持っている！</p>
            </div>
            <div style="padding-bottom: 10px; display: flex; align-items: center;">
              <p
                style="display: block; background:#0F9934; width: 20px; height: 20px; border-radius: 50%; margin-right: 10px;">
              </p>
              <p style="font-size: 120%; font-weight: bold;">国内でもトップクラスの求人数！</p>
            </div>
            <div style="display: flex; align-items: center;">
              <p
                style="display: block; background:#0F9934; width: 20px; height: 20px; border-radius: 50%; margin-right: 10px;">
              </p>
              <p style="font-size: 120%; font-weight: bold;">上場企業だから安心だよ！</p>
            </div>
            <p style="text-align: center;font-size: 100%;margin-top: 15px;">※連絡先がない人には<br>連絡できないから事前に確認してね！</p>
          </div>
        </div>

        <div style="text-align:center; background: #F7F7F7; padding: 10px; margin-top: 10px;"
          :id="!$globalVar.googleAdsTagCheck(clientId, permissionType) ? 'pdf-' + $globalVar.dn_flag + '-rt-completed' : clientId + '_' + permissionType + '_btn'"
          @click="$eventHub.$emit('send-jobs919-consult');">

          <!--企業ロゴ-->
          <div style="display: inline-block; min-width: 100%; text-align: center; padding: 10px;">
            <img src="/static/renew_img/job919_roo_yagish_logo.png" style="max-width: 90%;">
          </div>

          <p style="font-size: 16px; font-weight: bold;">
            <img src="/static/renew_img/check_icon.png" style="width:40px">規約に同意して無料相談を同意する
          </p>
        </div>
        <div class="text-center">
          <el-button :id="'pdf-' + $globalVar.dn_flag + '-rt-completed'" type="success" v-if="isJobs919Sended == false"
            style="background-color:#F60B26;border-color:#F60B26;font-size: 140%; padding: 20px;"
            @click="$eventHub.$emit('send-jobs919-consult');">登録をする</el-button>
          <el-button :id="'pdf-' + $globalVar.dn_flag + '-rt-completed-done'" type="success"
            v-if="isJobs919Sended == true" style="background-color:#0F9934;border-color:#0F9934;"
            @click="closeJobs919Dialog();">送信しました</el-button>
          <br />
        </div>

        <p style="font-size: 10px;">
          Yagishの<router-link id="footer-link-terms" :to="{ name: 'termsPage' }"
            target="_blank">利用規約</router-link>、<router-link id="footer-link-policy" :to="{ name: 'policyPage' }"
            target="_blank">個人情報保護方針</router-link>、<a href="https://www.yagish.jp/privacy_policy/"
            target="_blank">プライバシーポリシー</a><br />
          (株)クイックの<a href="https://www.kango-roo.com/career/rule" target="_blank">利用規約</a>、<a
            href="https://www.kango-roo.com/career/entry/ruleprivacy" target="_blank">個人情報保護方針</a>
        </p>
      </div>

    </div>
  </modal>
</template>
<style lang="scss" src="@/assets/scss/pages/pages.scss"></style>
<style lang="scss" src="@/assets/scss/pages/setting.scss"></style>
<script>
import { emitRtDialogClosedWithoutSubmit, wrapMittPopupHandler } from '@/plugins/emitter'
export default {
  components: {
  },
  data: function () {
    return {
      isMypage: false,
      clearLocalStorageConfirmVisible: false,
      currentFormat: {},
      formatid: '',
      previewHtml: '',
      permissionType: 1,
      isJobs919Sended: false,
      isMedlySended: false,
      isAdtopSended: false,
      isJigenSended: false,
      clientId: 'jobs919_mail',
      fullscreenLoading: false,
      username: '',
      baite_title: 'バイト',
      isAgree: true,
      basicData: {}
    }
  },
  created: function () {
    const app = this
    this.$iterateStorage(function (value, key, iterationNumber) {
      // console.log all the kay/value pairs
      if (key === 'basicData') {
        app.username = value.lastName + '_' + value.firstName
      }
    }, function (err) {
      if (!err) {
        console.log('Iteration has completed')
      }
    })
  },
  computed: {
    cleanedPreviewHtml: function () {
      // PDFで文字化けするやつを変換しておく
      return this.previewHtml
    },
    pdfFormData: function () {
      const formData = new FormData()
      formData.append('app_html', this.cleanedPreviewHtml)
      formData.append('pdf_option', 'A4')
      return formData
    }
  },
  methods: {
    openJobs919Dialog: function (id, html, permissionType, basicData, isMypage = false) {
      this.isMypage = isMypage
      this.formatid = id
      this.previewHtml = html.$el.innerHTML
      this.clearLocalStorageConfirmVisible = false
      this.permissionType = permissionType
      this.basicData = basicData

      this.$modal.show('jobs919-dialog')
      const formData = new FormData()
      formData.append('uuid', this.$firebase.user.uid)
      formData.append('format_id', this.formatid)
      formData.append('dialog_name', 'jobs919_dialog')
      formData.append('permission_type', this.permissionType)
      formData.append('device_flg', this.$deviceLib.isMobileDevice ? 'SP' : 'PC')
      formData.append('version', '2')
      formData.append('is_mypage', this.isMypage ? 'true' : 'false')
      formData.append('site_flag', 'r')
      formData.append('app_flag', this.$site.appFlag)
      const app = this
      this.$axios.post(this.$varuna.endPoints.displayDialog, formData, { timeout: 60000 })
      this.$iterateStorage(function (value, key, iterationNumber) {
        // console.log all the kay/value pairs
        if (key === 'basicData') {
          app.username = value.lastName + '_' + value.firstName
        }
      }, function (err) {
        if (!err) {
          console.log('Iteration has completed')
        }
      })
      this.isJobs919Sended = false
    },
    closeJobs919Dialog: function () {
      this.$eventHub.$emit('update_rt_condition', this.clientId, this.permissionType)
      this.$modal.hide('jobs919-dialog')
      this.clearLocalStorageConfirmVisible = false
      // before-close の判定に影響しないように、送信状態のリセットは閉じた後に行う
      this.$nextTick(() => {
        this.isJobs919Sended = false
      })
    },
    handleBeforeClose: function (event) {
      if (!this.isJobs919Sended) {
        this.$eventHub.$emit('update_rt_condition', this.clientId, this.permissionType)
        emitRtDialogClosedWithoutSubmit()
      }
    },
    confirmWin: function () {
      confirm('応募するデータを送信します。よろしいでしょうか。')
    },
    clearLocalStorage: function () {
      this.$clearStorage()
      window.location = '/'
    },
    createFilename: function (ext) {
      const now = new Date()
      const prefix = process.env.VUE_APP_DOWNLOAD_FILENAME_PREFIX
      const dateString = this.$formLib.dateFormat(now, '_yyyy-mm-dd_HH-MM-ss')
      return `${prefix}${this.formatid}${dateString}.${ext}`
    },
    sendJobs919Consult: async function () {
      if (!this.isAgree) {
        this.$message({
          message: 'チェックしてから同意ボタンを押してください。',
          type: 'error'
        })
        return
      }
      if (!this.$deviceLib.isOnline) {
        this.$message({
          message: '現在オフラインです。インターネットにつながってから再度お試しください',
          type: 'warning'
        })
        return
      }
      if (this.isJobs919Sended) {
        return
      }
      await this.$firebase.reloadToken()
      const accessToken = this.$firebase.accessToken
      if (!accessToken || !this.$firebase.user.email) {
        this.$message({
          message: 'ログインが必要です',
          type: 'warning'
        })
        return
      }
      this.fullscreenLoading = true
      const formData = this.pdfFormData
      formData.append('token', accessToken)
      formData.append('apikey', this.$firebase.config.apiKey)
      formData.append('uuid', this.$firebase.user.uid)
      formData.append('format_id', this.formatid)
      formData.append('yaginame', this.username)
      formData.append('app_flag', this.$site.appFlag)
      formData.append('dialog_name', 'jobs919_dialog')
      formData.append('storage_data', JSON.stringify(this.basicData))
      formData.append('permission_type', this.permissionType)
      formData.append('filename', this.createFilename('pdf'))
      formData.append('device_flg', this.$deviceLib.isMobileDevice ? 'SP' : 'PC')
      formData.append('version', '3')
      formData.append('is_mypage', this.isMypage ? 'true' : 'false')
      formData.append('reqflg', '2')
      const app = this
      this.$axios
        .post(this.$varuna.endPoints.sendJobs919, formData, { timeout: 60000 })
        .then(function (response) {
          app.isJobs919Sended = true
          app.$globalVar.eventTag()
          app.$eventHub.$emit('update_rt_condition', app.clientId, app.permissionType)
        })
        .catch(function (error) {
          app.$message({
            message: '送信失敗しました',
            type: 'error'
          })
          app.$gtm.sendError('pdf mail', `send pdf mail failed ${error}`)
        }).finally(function () {
          app.fullscreenLoading = false
        })
    }
  },
  beforeMount: function () {
    this.$eventHub.$on('send-jobs919-consult', this.sendJobs919Consult)
    // emitGlobalVarPopupDialog → mitt 直購読（GLOBAL_VAR_POPUP_EVENT_TYPES / emitter.js）
    this._mittGVPopup_openJobs919Dialog = wrapMittPopupHandler(this, 'openJobs919Dialog')
    this.$emitter.on('open-jobs919-dialog', this._mittGVPopup_openJobs919Dialog)
    this.$eventHub.$on('popstate', this.closeJobs919Dialog)
  },
  destroyed: function () {
    this.$eventHub.$off('send-jobs919-consult', this.sendJobs919Consult)
    this.$emitter.off('open-jobs919-dialog', this._mittGVPopup_openJobs919Dialog)
    this.$eventHub.$off('popstate', this.closeJobs919Dialog)
  }
}
</script>
